const { isMobile } = require("../../scripts/helpers");

class CarouselMedium {
  constructor() {
    this.initSlick();
  }

  initSlick() {
    if(isMobile()) {
      $('.carousel-medium__slider').slick({
        centerMode: true,
        centerPadding: '20px',
        slidesToShow: 1,
        dots: true,
        arrows: false,
        slidesToScroll: 1,
        mobileFirst: true,
        responsive: [
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              infinite: true,
              dots: true
            }
          }
        ]
      });
    }
    }
}

$(document).ready(function() {
  const carouselMedium = new CarouselMedium();
});